<div class="col-12">
    <div class="clientportal-app-card">
        <!-- HEADER -->
        <div class="clientportal-app-card-header">
            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1">
                <h3 class="clientportal-app-card-title m-6">
                    <div *ngIf="electricityDetail" class="d-flex align-items-center">
                        <i class="fas fa-bolt section-icon me-2"></i>
                        <h2 class="mb-0">{{ electricityEquipment.electricityMeterCode }}</h2>
                    </div>
                    <div *ngIf="gasDetail" class="d-flex align-items-center">
                        <i class="fas fa-fire section-icon me-2"></i>
                        <h2 class="mb-0">{{ gasEquipment.naturalGasMeterCode }}</h2>
                    </div>
                    <div *ngIf="selfConsumptionDetail" class="d-flex align-items-center">
                        <i class="fas fa-solar-panel section-icon me-2"></i>
                        <h2 class="mb-0">{{ selfConsumptionEquipment.electricityMeterCode }}</h2>
                    </div>
                </h3>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="tabLayout$ | async as tabLayout">
    <div class="col-12">
        <is-tab-layout [tabLayout$]="tabLayout$" (onSelectedTab)="onTabChange($event)"></is-tab-layout>
    </div>
    <ng-container *ngIf="electricityDetail">
        <div class="row g-3">
            <ng-container *ngIf="selectedTab == 0">
                <!-- Eletricity Supply Info -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-elecSupplyInfo"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-elecSupplyInfo">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'ELECTRICITY_SUPPLY_INFO' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-elecSupplyInfo" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <!-- CPE Code -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'CPE_CODE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityEquipment.electricityMeterCode }}
                                                </div>
                                            </div>

                                            <!-- ISP -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'IS_ISP_FREE' | translate }}</label>
                                                <div class="hover-td">
                                                    <mat-slide-toggle [(ngModel)]="electricityDetail.electricityMeter.isISPFree" color="primary" class="text-mv-gray" [disabled]="true">
                                                    </mat-slide-toggle>
                                                    <span class="ms-2">
                                                        {{ electricityDetail.electricityMeter.isISPFree ? 'YES' : 'NO' | translate }}
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Address -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'ADDRESS' | translate }}</label>
                                                <div class="hover-td">
                                                    <span>{{ electricityDetail.electricityMeter.address.street ?? '' + ' ' + electricityDetail.electricityMeter.address.doorNumber ?? '' }}</span>
                                                    <span><br>{{ electricityDetail.electricityMeter.address.postalCode ?? '' + ' ' + electricityDetail.electricityMeter.address.postalCodeName ?? '' }}</span>
                                                </div>
                                            </div>
                                            
                                            <!-- County -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'COUNTY' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.electricityMeter.address.county }}
                                                </div>
                                            </div>

                                            <!-- District -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'DISTRICT' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.electricityMeter.address.district }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Supply -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-elecSupply"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-supply">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'SUPPLY' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-elecSupply" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <!-- CPE Code -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'TENSION_LEVEL' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityEquipment.tensionLevel }}
                                                </div>
                                            </div>

                                            <!-- Count -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'COUNT' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.countType }}
                                                </div>
                                            </div>

                                            <!-- Time Cycle -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'TIME_CYCLE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.timeCycle }}
                                                </div>
                                            </div>
                                            
                                            <!-- Contracted Power -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'COUNTY' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.contractedPower }}
                                                </div>
                                            </div>

                                            <!-- Client Request Start Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'CLIENT_REQUEST_START_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.clientRequestedDeliveryStartDate | date:'dd/MM/yyyy' }}
                                                </div>
                                            </div>

                                            <!-- Loyalty Period -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'LOYALTY_PERIOD' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.deliveryContractDurationMonths }} {{ 'MONTH_S' | translate}} {{ ' / ' }} {{ electricityDetail.deliveryContractDurationDays }} {{ 'DAY_S' | translate}}
                                                </div>
                                            </div>

                                            <!-- Delivery Start Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'DELIVERY_START_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.deliveryStartDate | date:'dd/MM/yyyy' }}
                                                </div>
                                            </div>

                                            <!-- Delivery End Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'DELIVERY_END_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{( electricityDetail.deliveryEndDate | date:'dd/MM/yyyy' ) ?? ''}}<br>
                                                    {{ electricityDetail.deliveryEstimatedEndDate | date:'dd/MM/yyyy' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Economic Conditions -->
                <ng-container *ngIf="electricityDetail.economicConditions.length > 0">
                    <div class="col-12 ">
                        <div class="clientportal-app-card">
                            <!-- HEADER -->
                            <div class="clientportal-app-card-header">
                                <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                    role="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#cardCollapse-elecEconomicConditions"
                                    aria-expanded="true"
                                    aria-controls="cardCollapse-elecEconomicConditions">
                                    <h3 class="clientportal-app-card-title m-6">
                                        <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                        {{ 'ECONOMIC_CONDITIONS' | translate }}
                                        <span class="clientportal-app-card-chevron" aria-hidden="true">
                                            <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                            <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                        </span>
                                    </h3>
                                </div>
                            </div>

                            <!-- BODY -->
                            <div id="cardCollapse-elecEconomicConditions" class="collapse show">
                                <div class="clientportal-app-card-body">
                                    <div class="row g-3">
                                        <div class="col-sm-12">
                                            <div class="row g-3">
                                                <table mat-table #economicConditionsTable [dataSource]="economicConditionsDataSource">
                                                    <!-- Contracted Price Column -->
                                                    <ng-container matColumnDef="CONTRACTED_PRICE">
                                                        <th mat-header-cell *matHeaderCellDef> {{ 'CONTRACTED_PRICE' | translate }} </th>
                                                        <td mat-cell *matCellDef="let row"> {{ row.contractedPriceType | translate }} </td>
                                                    </ng-container>

                                                    <!-- Start Date Column -->
                                                    <ng-container matColumnDef="START_DATE">
                                                        <th mat-header-cell *matHeaderCellDef>{{ 'START_DATE' | translate }}</th>
                                                        <td mat-cell *matCellDef="let row">{{ row.startDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                                                    </ng-container>

                                                    <!-- End Date Column -->
                                                    <ng-container matColumnDef="END_DATE">
                                                        <th mat-header-cell *matHeaderCellDef>{{ 'END_DATE' | translate }}</th>
                                                        <td mat-cell *matCellDef="let row">{{ row.endDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                                                    </ng-container>
                                                    
                                                    <!-- <ng-container matColumnDef="ACTIONS">
                                                        <th mat-header-cell *matHeaderCellDef></th>
                                                        <td mat-cell *matCellDef="let item">
                                                            <button mat-button class="btn fa-plus text-grey" (click)="historyClick(item.guidId)">{{ 'VIEW_HISTORY' | translate }}</button>
                                                        </td>
                                                    </ng-container> -->

                                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsEconomicConditions" class="dotted-line-table"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsEconomicConditions;" class="dotted-line-table"></tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </ng-container>

                <!-- Consumption -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-elecConsumption"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-elecConsumption">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'CONSUMPTION' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-elecConsumption" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <!-- Annual Estimated -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'ESTIMATED_ANNUAL' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.estimatedAnnualConsumption }}
                                                </div>
                                            </div>

                                            <!-- Total Estimated -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'TOTAL_ESTIMATED' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.estimatedTotalConsumption }}
                                                </div>
                                            </div>

                                            <!-- Annual Estimated Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'ESTIMATED_ANNUAL_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.estimatedAnnualConsumptionDate | date:'dd/MM/yyyy' }}
                                                </div>
                                            </div>

                                            <!-- Annual Validated -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'VALIDATED_ANNUAL' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.validatedAnnualConsumption }}
                                                </div>
                                            </div>

                                            <!-- Total Validated -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'TOTAL_VALIDATED' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ electricityDetail.validatedTotalConsumption }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="selectedTab == 1">
                <!-- History -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-elecHistory"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-elecHistory">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'HISTORY' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-elecHistory" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <table mat-table #historyTable [dataSource]="historyDataSource">
                                                <!-- Type Column -->
                                                <ng-container matColumnDef="TYPE">
                                                    <th mat-header-cell *matHeaderCellDef> {{ 'TYPE' | translate }} </th>
                                                    <td mat-cell *matCellDef="let row"> {{ row.type.toUpperCase() | translate }} </td>
                                                </ng-container>

                                                <!-- Modification Date Column -->
                                                <ng-container matColumnDef="MODIFICATION_DATE">
                                                    <th mat-header-cell *matHeaderCellDef>{{ 'MODIFICATION_DATE' | translate }}</th>
                                                    <td mat-cell *matCellDef="let row">{{ row.modificationDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                                                </ng-container>

                                                <!-- Modification By Column -->
                                                <ng-container matColumnDef="MODIFICATION_BY">
                                                    <th mat-header-cell *matHeaderCellDef>{{ 'MODIFICATION_BY' | translate }}</th>
                                                    <td mat-cell *matCellDef="let row">{{ row.modifiedBy }}</td>
                                                </ng-container>
                                                
                                                <!-- <ng-container matColumnDef="ACTIONS">
                                                    <th mat-header-cell *matHeaderCellDef></th>
                                                    <td mat-cell *matCellDef="let item">
                                                        <button mat-button class="btn fa-plus text-grey" (click)="historyClick(item.guidId)">{{ 'VIEW_HISTORY' | translate }}</button>
                                                    </td>
                                                </ng-container> -->

                                                <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory" class="dotted-line-table"></tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumnsHistory;" class="dotted-line-table"></tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="gasDetail">
        <div class="row g-3">
            <ng-container *ngIf="selectedTab == 0">
                <!-- Natural Gas Supply Info -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-gasSupplyInfo"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-gasSupplyInfo">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'NATURAL_GAS_SUPPLY_INFO' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-gasSupplyInfo" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <!-- CUI Code -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'CUI_CODE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasEquipment.naturalGasMeterCode }}
                                                </div>
                                            </div>

                                            <!-- ISP -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'IS_ISP_FREE' | translate }}</label>
                                                <div class="hover-td">
                                                    <!-- <mat-slide-toggle [(ngModel)]="gasDetail.naturalGasMeter.isISPFree" color="primary" class="text-mv-gray" [disabled]="true">
                                                    </mat-slide-toggle>
                                                    <span class="ms-2">
                                                        {{ gasDetail.naturalGasMeter.isISPFree ? 'YES' : 'NO' | translate }}
                                                    </span> -->
                                                </div>
                                            </div>

                                            <!-- Address -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'ADDRESS' | translate }}</label>
                                                <div class="hover-td">
                                                    <span>{{ gasDetail.naturalGasMeter.address.street ?? '' + ' ' + gasDetail.naturalGasMeter.address.doorNumber ?? '' }}</span>
                                                    <span><br>{{ gasDetail.naturalGasMeter.address.postalCode ?? '' + ' ' + gasDetail.naturalGasMeter.address.postalCodeName ?? '' }}</span>
                                                </div>
                                            </div>
                                            
                                            <!-- County -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'COUNTY' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.naturalGasMeter.address.county }}
                                                </div>
                                            </div>

                                            <!-- District -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'DISTRICT' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.naturalGasMeter.address.district }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Supply -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-gasSupply"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-gasSupply">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'SUPPLY' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-gasSupply" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <!-- Pressure Level -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'PRESSURE_LEVEL' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.pressureLevel }}
                                                </div>
                                            </div>

                                            <!-- TARIFF -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'TARIFF' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.tariff }}
                                                </div>
                                            </div>

                                            <!-- Client Request Delivery Start Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'CLIENT_REQUESTED_DELIVERY_START_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.clientRequestedDeliveryStartDate | date:'dd/MM/yyyy' }}
                                                </div>
                                            </div>

                                            <!-- Loyalty Period -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'LOYALTY_PERIOD' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.deliveryContractDurationMonths }} {{ 'MONTH_S' | translate}} {{ ' / ' }} {{ electricityDetail.deliveryContractDurationDays }} {{ 'DAY_S' | translate}}
                                                </div>
                                            </div>

                                            <!-- Delivery Start Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'DELIVERY_START_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.deliveryStartDate | date:'dd/MM/yyyy' }}
                                                </div>
                                            </div>

                                            <!-- Delivery End Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'DELIVERY_END_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.deliveryEndDate | date:'dd/MM/yyyy' }}<br>
                                                    {{ gasDetail.deliveryEstimatedEndDate | date:'dd/MM/yyyy' }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Economic Conditions -->
                <ng-container *ngIf="gasDetail.economicConditions.length > 0">
                    <div class="col-12 ">
                        <div class="clientportal-app-card">
                            <!-- HEADER -->
                            <div class="clientportal-app-card-header">
                                <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                    role="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#cardCollapse-gasEconomicConditions"
                                    aria-expanded="true"
                                    aria-controls="cardCollapse-gasEconomicConditions">
                                    <h3 class="clientportal-app-card-title m-6">
                                        <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                        {{ 'ECONOMIC_CONDITIONS' | translate }}
                                        <span class="clientportal-app-card-chevron" aria-hidden="true">
                                            <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                            <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                        </span>
                                    </h3>
                                </div>
                            </div>

                            <!-- BODY -->
                            <div id="cardCollapse-elecEconomicConditions" class="collapse show">
                                <div class="clientportal-app-card-body">
                                    <div class="row g-3">
                                        <div class="col-sm-12">
                                            <div class="row g-3">
                                                <table mat-table #economicConditionsTable [dataSource]="economicConditionsDataSource">
                                                    <!-- Contracted Price Column -->
                                                    <ng-container matColumnDef="CONTRACTED_PRICE">
                                                        <th mat-header-cell *matHeaderCellDef> {{ 'CONTRACTED_PRICE' | translate }} </th>
                                                        <td mat-cell *matCellDef="let row"> {{ row.contractedPriceType | translate }} </td>
                                                    </ng-container>

                                                    <!-- Start Date Column -->
                                                    <ng-container matColumnDef="START_DATE">
                                                        <th mat-header-cell *matHeaderCellDef>{{ 'START_DATE' | translate }}</th>
                                                        <td mat-cell *matCellDef="let row">{{ row.startDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                                                    </ng-container>

                                                    <!-- End Date Column -->
                                                    <ng-container matColumnDef="END_DATE">
                                                        <th mat-header-cell *matHeaderCellDef>{{ 'END_DATE' | translate }}</th>
                                                        <td mat-cell *matCellDef="let row">{{ row.endDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                                                    </ng-container>
                                                    
                                                    <!-- <ng-container matColumnDef="ACTIONS">
                                                        <th mat-header-cell *matHeaderCellDef></th>
                                                        <td mat-cell *matCellDef="let item">
                                                            <button mat-button class="btn fa-plus text-grey" (click)="historyClick(item.guidId)">{{ 'VIEW_HISTORY' | translate }}</button>
                                                        </td>
                                                    </ng-container> -->

                                                    <tr mat-header-row *matHeaderRowDef="displayedColumnsEconomicConditions" class="dotted-line-table"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayedColumnsEconomicConditions;" class="dotted-line-table"></tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </ng-container>

                <!-- Consumption -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-gasConsumption"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-gasConsumption">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'CONSUMPTION' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-gasConsumption" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <!-- Annual Estimated -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'ESTIMATED_ANNUAL' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.estimatedAnnualConsumption }}
                                                </div>
                                            </div>

                                            <!-- Total Estimated -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'TOTAL_ESTIMATED' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.estimatedTotalConsumption }}
                                                </div>
                                            </div>

                                            <!-- Annual Estimated Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'ESTIMATED_ANNUAL_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.estimatedAnnualConsumptionDate | date:'dd/MM/yyyy' }}
                                                </div>
                                            </div>

                                            <!-- Annual Validated -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'VALIDATED_ANNUAL' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.validatedAnnualConsumption }}
                                                </div>
                                            </div>

                                            <!-- Total Validated -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'TOTAL_VALIDATED' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ gasDetail.validatedTotalConsumption }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="selectedTab == 1">
                <!-- History -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-gasHistory"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-gasHistory">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'HISTORY' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-gasHistory" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <table mat-table #historyTable [dataSource]="historyDataSource">
                                                <!-- Type Column -->
                                                <ng-container matColumnDef="TYPE">
                                                    <th mat-header-cell *matHeaderCellDef> {{ 'TYPE' | translate }} </th>
                                                    <td mat-cell *matCellDef="let row"> {{ row.type.toUpperCase() | translate }} </td>
                                                </ng-container>

                                                <!-- Modification Date Column -->
                                                <ng-container matColumnDef="MODIFICATION_DATE">
                                                    <th mat-header-cell *matHeaderCellDef>{{ 'MODIFICATION_DATE' | translate }}</th>
                                                    <td mat-cell *matCellDef="let row">{{ row.modificationDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                                                </ng-container>

                                                <!-- Modification By Column -->
                                                <ng-container matColumnDef="MODIFICATION_BY">
                                                    <th mat-header-cell *matHeaderCellDef>{{ 'MODIFICATION_BY' | translate }}</th>
                                                    <td mat-cell *matCellDef="let row">{{ row.modifiedBy }}</td>
                                                </ng-container>

                                                <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory" class="dotted-line-table"></tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumnsHistory;" class="dotted-line-table"></tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="selfConsumptionDetail">
        <div class="row g-3">
            <ng-container *ngIf="selectedTab == 0">
                <!-- SelfConsumption Supply Info -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-selfConsumptionSupplyInfo"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-selfConsumptionSupplyInfo">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'SELFCONSUMPTION_SUPPLY_INFO' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-selfConsumptionSupplyInfo" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <!-- CPE Code -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'CPE_CODE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionEquipment.electricityMeterCode }}
                                                </div>
                                            </div>

                                            <!-- ISP -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'IS_ISP_FREE' | translate }}</label>
                                                <div class="hover-td">
                                                    <mat-slide-toggle [(ngModel)]="selfConsumptionDetail.electricityMeter.isISPFree" color="primary" class="text-mv-gray" [disabled]="true">
                                                    </mat-slide-toggle>
                                                    <span class="ms-2">
                                                        {{ selfConsumptionDetail.electricityMeter.isISPFree ? 'YES' : 'NO' | translate }}
                                                    </span>
                                                </div>
                                            </div>

                                            <!-- Address -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'ADDRESS' | translate }}</label>
                                                <div class="hover-td">
                                                    <span>{{ selfConsumptionDetail.electricityMeter.address.street ?? '' + ' ' + selfConsumptionDetail.electricityMeter.address.doorNumber ?? '' }}</span>
                                                    <span><br>{{ selfConsumptionDetail.electricityMeter.address.postalCode ?? '' + ' ' + selfConsumptionDetail.electricityMeter.address.postalCodeName ?? '' }}</span>
                                                </div>
                                            </div>
                                            
                                            <!-- County -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'COUNTY' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionDetail.electricityMeter.address.county }}
                                                </div>
                                            </div>

                                            <!-- District -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'DISTRICT' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionDetail.electricityMeter.address.district }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Supply -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-selfConsumptionSupply"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-selfConsumptionSupply">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'SUPPLY' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-selfConsumptionSupply" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <!-- Client Request Installation Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'CLIENT_REQUEST_INSTALLATION_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    <span>{{ selfConsumptionEquipment.clientRequestedInstallationDate | date:'dd/MM/yyyy' }}</span>
                                                </div>
                                            </div>

                                            <!-- Installation Date -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'INSTALLATION_DATE' | translate }}</label>
                                                <div class="hover-td">
                                                    <span>{{ selfConsumptionDetail.installationDate | date:'dd/MM/yyyy' }}</span>
                                                </div>
                                            </div>

                                            <!-- Panels Number -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'PANELS_NUMBER' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionDetail.numberOfPanels }}
                                                </div>
                                            </div>
                                            
                                            <!-- Inverters Number -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'INVERTERS_NUMBER' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionDetail.numberOfInverters }}
                                                </div>
                                            </div>

                                            <!-- Batteries Number -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'BATTERIES_NUMBER' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionDetail.numberOfBatteries ?? 0 }}
                                                </div>
                                            </div>

                                            <!-- Power -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'POWER' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionDetail.power }}
                                                </div>
                                            </div>

                                            <!-- Value -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'VALUE' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionDetail.value }}
                                                </div>
                                            </div>

                                            <!-- Payback Years -->
                                            <div class="col-sm-6 col-xl-4">
                                                <label class="text-muted small fw-medium">{{ 'PAYBACK_YEARS' | translate }}</label>
                                                <div class="hover-td">
                                                    {{ selfConsumptionDetail.paybackYears }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="selectedTab == 1">
                <!-- History -->
                <div class="col-12 ">
                    <div class="clientportal-app-card">
                        <!-- HEADER -->
                        <div class="clientportal-app-card-header">
                            <div class="clientportal-app-card-toggler d-flex align-items-center flex-grow-1"
                                 role="button"
                                 data-bs-toggle="collapse"
                                 data-bs-target="#cardCollapse-selfConsumptionHistory"
                                 aria-expanded="true"
                                 aria-controls="cardCollapse-selfConsumptionHistory">
                                <h3 class="clientportal-app-card-title m-6">
                                    <i class="fal fa-list clientportal-app-card-title-icon"></i>
                                    {{ 'HISTORY' | translate }}
                                    <span class="clientportal-app-card-chevron" aria-hidden="true">
                                        <i class="fal fa-chevron-down fs-8 chev-open"></i>
                                        <i class="fal fa-chevron-right fs-8 chev-closed"></i>
                                    </span>
                                </h3>
                            </div>
                        </div>

                        <!-- BODY -->
                        <div id="cardCollapse-selfConsumptionHistory" class="collapse show">
                            <div class="clientportal-app-card-body">
                                <div class="row g-3">
                                    <div class="col-sm-12">
                                        <div class="row g-3">
                                            <table mat-table #historyTable [dataSource]="historyDataSource">
                                                <!-- Type Column -->
                                                <ng-container matColumnDef="TYPE">
                                                    <th mat-header-cell *matHeaderCellDef> {{ 'TYPE' | translate }} </th>
                                                    <td mat-cell *matCellDef="let row"> {{ row.type.toUpperCase() | translate }} </td>
                                                </ng-container>

                                                <!-- Modification Date Column -->
                                                <ng-container matColumnDef="MODIFICATION_DATE">
                                                    <th mat-header-cell *matHeaderCellDef>{{ 'MODIFICATION_DATE' | translate }}</th>
                                                    <td mat-cell *matCellDef="let row">{{ row.modificationDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                                                </ng-container>

                                                <!-- Modification By Column -->
                                                <ng-container matColumnDef="MODIFICATION_BY">
                                                    <th mat-header-cell *matHeaderCellDef>{{ 'MODIFICATION_BY' | translate }}</th>
                                                    <td mat-cell *matCellDef="let row">{{ row.modifiedBy }}</td>
                                                </ng-container>
                                                
                                                <!-- <ng-container matColumnDef="ACTIONS">
                                                    <th mat-header-cell *matHeaderCellDef></th>
                                                    <td mat-cell *matCellDef="let item">
                                                        <button mat-button class="btn fa-plus text-grey" (click)="historyClick(item.guidId)">{{ 'VIEW_HISTORY' | translate }}</button>
                                                    </td>
                                                </ng-container> -->

                                                <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory" class="dotted-line-table"></tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumnsHistory;" class="dotted-line-table"></tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-container>